export default __webpack_public_path__ + "6f349d23eddf2aaaec8f5dd9f4785e7a.png";